import React, { useState } from "react";
import Vibrant from 'node-vibrant';
import defaultLogo from './assets/img/elements/default-logo.jpg';

function ClearbitImage({ url, size, onLoaded, className, style }) {

  const [backgroundColor, setBackgroundColor] = useState( "#222" );

  const imgSrc = `//logo.clearbit.com/${url}?size=${ size }`;

  const imgLoaded = ({ target }) => {
    const vibrant = new Vibrant(target);

    vibrant.getPalette( (err, palette) => {
      if( palette )
      {
        setBackgroundColor( palette.Vibrant.hex );
        onLoaded({
          backgroundColor: palette.Vibrant.hex,
          src: target.src
        });
      }
    });

  }

  const imgLoadError = ({ target }) => {
    target.src = defaultLogo;
  }


  return (
    <img alt="school logo" onLoad={ imgLoaded } onError={ imgLoadError } className={ className } style={ style } crossOrigin='anonymous' src={ imgSrc }/>
  )

};

ClearbitImage.defaultProps = {
  onLoaded: () => {}
}

export default ClearbitImage;
